import Blockly from 'blockly/browser'
import { defineStmtBlock } from '../Util'

defineStmtBlock(
  'sirenia_api_timer_start',
  {
    message0: 'start timer %1',
    args0: [
      {
        type: 'input_value',
        name: 'NAME',
        check: 'String'
      }
    ],
    tooltip: 'Starts a named timer',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#timer'
  },
  function(block) {
    var name =
      Blockly.JavaScript.valueToCode(block, 'NAME', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Timer.start(${name});\n`
  }
)

defineStmtBlock(
  'sirenia_api_timer_log',
  {
    message0: 'log text %1 with timer %2',
    args0: [
      {
        type: 'input_value',
        name: 'MESSAGE',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'NAME',
        check: 'String'
      }
    ],
    tooltip: 'Starts a named timer',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#timer'
  },
  function(block) {
    var name =
      Blockly.JavaScript.valueToCode(block, 'NAME', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var message =
      Blockly.JavaScript.valueToCode(block, 'MESSAGE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Timer.log(${name}, ${message});\n`
  }
)

defineStmtBlock(
  'sirenia_api_timer_stop',
  {
    message0: 'stop timer %1 (silent %2)',
    args0: [
      {
        type: 'input_value',
        name: 'NAME',
        check: 'String'
      },
      {
        type: 'field_checkbox',
        name: 'SILENT',
        checked: true
      }
    ],
    tooltip: 'Starts a named timer',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#timer'
  },
  function(block) {
    var name =
      Blockly.JavaScript.valueToCode(block, 'NAME', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var logMessage = block.getFieldValue('SILENT') === 'TRUE' ? '' : ', true'
    return `Timer.stop(${name}${logMessage});\n`
  }
)
